import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

// Router
import { Router } from '@angular/router';

// RxJS
import { Observable } from 'rxjs';

// Services
import { AuthService } from '../services/auth.service';
import { TokenService } from '../services/token.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private tokenService: TokenService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.tokenService.getToken();

    if (!token) return next.handle(request);

    const isExpired = this.tokenService.isExpired();

    if (isExpired) {
      this.authService.logOut();
      this.router.navigate(['/auth/login']);
    }

    const requestClone = request.clone({
      headers: request.headers.set('Authorization', `Bearer ${token}`),
    });

    return next.handle(requestClone);
  }
}
